import { createFileRoute, Link } from "@tanstack/react-router";
import { FileText } from "lucide-react";
import { formatDate } from "@/utils/formatDate";
import { PageHeader } from "@/components/PageHeader";
import { NeonCard } from "@/components/NeonCard";
import { listPublishedPosts, type PublicPost } from "@/lib/public-content.functions";
import { buildMeta } from "@/lib/seo";
import { errorMessage } from "@/lib/error-capture";

export const Route = createFileRoute("/blog")({
  head: () =>
    buildMeta({
      title: "Blog",
      description:
        "Persönliche Blog-Einträge, philosophische Notizen und Projekt-Updates rund um Restlicht, Harm Reduction und medizinisches Cannabis.",
      path: "/blog",
      image: "https://restlicht.fyi/og-blog.jpg",
    }),

  loader: () => listPublishedPosts({ data: { type: "blog" } }),
  errorComponent: ({ error }) => <div role="alert" style={{ padding: "2rem", color: "var(--text-secondary)" }}>Fehler: {errorMessage(error)}</div>,
  notFoundComponent: () => <div style={{ padding: "2rem" }}>Keine Blog-Einträge gefunden.</div>,
  component: Blog,
});

function Blog() {
  const items = Route.useLoaderData();

  return (
    <div data-section="blog">
      <PageHeader icon={<FileText size={28} />} title="Blog" />
      <div className="posts-grid">
        {items.map((p: PublicPost) => (
          <NeonCard as="article" key={p.id} style={{ padding: "1.5rem", display: "flex", flexDirection: "column" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span style={{ color: "var(--text-secondary)", fontSize: "0.85rem" }}>{formatDate(p.published_date)}</span>
              <span
                style={{
                  background: "var(--accent-bg)",
                  color: "var(--accent)",
                  border: "1px solid var(--accent-border)",
                  borderRadius: "20px",
                  padding: "0.2rem 0.6rem",
                  fontSize: "0.8rem",
                  textTransform: "uppercase",
                  letterSpacing: "0.05em",
                }}
              >
                Blog
              </span>
            </div>
            <h2 style={{ fontSize: "1.15rem", fontWeight: 700, color: "var(--text-primary)", marginTop: "0.5rem" }}>
              {p.title}
            </h2>
            <p style={{ color: "var(--text-secondary)", fontSize: "0.9rem", marginTop: "0.4rem", flex: 1 }}>{p.excerpt}</p>
            <Link
              to="/blog/$slug"
              params={{ slug: p.slug }}
              style={{ color: "var(--accent)", fontSize: "0.85rem", marginTop: "1rem", textDecoration: "none" }}
            >
              Weiterlesen →
            </Link>
          </NeonCard>
        ))}
      </div>
    </div>
  );
}
